import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPosts(ctx, params) {
      return axios.get('blog/posts', { params })
    },
    fetchPost(ctx, id) {
      return axios.get(`blog/posts/${id}`)
    },
    createPost(ctx, data) {
      return axios.post('blog/posts', data)
    },
    updatePost(ctx, { id, data }) {
      return axios.put(`blog/posts/${id}`, data)
    },
    deletePost(ctx, id) {
      return axios.delete(`blog/posts/${id}`)
    },
    fetchCategorias() {
      return axios.get('blog/categorias')
    },
    createCategoria(ctx, data) {
      return axios.post('blog/categorias', data)
    },
    updateCategoria(ctx, { id, data }) {
      return axios.put(`blog/categorias/${id}`, data)
    },
    deleteCategoria(ctx, id) {
      return axios.delete(`blog/categorias/${id}`)
    },
    blogAi(ctx, data) {
      return axios.post('blog/ai', data)
    },
    fetchAiAgentSettings() {
      return axios.get('blog/ai-agent/settings')
    },
    updateAiAgentSettings(ctx, data) {
      return axios.put('blog/ai-agent/settings', data)
    },
    fetchTrainingData() {
      return axios.get('blog/ai-agent/training')
    },
    createTrainingData(ctx, data) {
      return axios.post('blog/ai-agent/training', data)
    },
    updateTrainingData(ctx, { id, data }) {
      return axios.put(`blog/ai-agent/training/${id}`, data)
    },
    deleteTrainingData(ctx, id) {
      return axios.delete(`blog/ai-agent/training/${id}`)
    },
    toggleTrainingData(ctx, id) {
      return axios.patch(`blog/ai-agent/training/${id}/toggle`)
    },
    wordpressImport(ctx, data) {
      return axios.post('blog/wordpress-import', data)
    },
    submitReview(ctx, data) {
      return axios.post('blog/reviews', data)
    },
    fetchReviews(ctx, postId) {
      return axios.get(`blog/reviews/${postId}`)
    },
  },
}
